import React from "react";
import { Box, Typography } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Clickable summary card with leading icon block,
 * a big tabular-numeric value, label, and optional sub-line.
 */
const StatTile = ({
  icon,
  iconBg = TOKENS.primaryTint,
  iconInk = TOKENS.primaryInk,
  value,
  label,
  sub,
  active = false,
  onClick,
}) => {
  const clickable = typeof onClick === "function";
  return (
    <Box
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: "16px",
        py: "14px",
        borderRadius: `${TOKENS.radiusS}px`,
        border: `1px solid ${active ? TOKENS.primary : TOKENS.border}`,
        background: TOKENS.bgSurface,
        boxShadow: active ? TOKENS.shadowFocus : TOKENS.shadowXs,
        cursor: clickable ? "pointer" : "default",
        transition: "border-color 120ms ease, box-shadow 120ms ease",
        "&:hover": clickable
          ? { borderColor: TOKENS.primary, boxShadow: TOKENS.shadowS }
          : undefined,
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: `${TOKENS.radiusXs}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: iconBg,
          color: iconInk,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.1,
            color: TOKENS.fg1,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {value}
        </Typography>
        <Typography sx={{ fontSize: 12.5, color: TOKENS.fg2, mt: "2px" }}>
          {label}
        </Typography>
        {sub ? (
          <Typography sx={{ fontSize: 11.5, color: TOKENS.fg3, mt: "1px" }}>
            {sub}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default StatTile;
